/*
 * Module for the _MessageThreads partial view
*/
rs.module("ui/content/communications/messagecenter/messagethreads",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, backendUrls, listApi) {

            // make sure detail is scrolled to the bottom to show latest messages
            listApi.detail.scrollDetailToBottom();
            $(document).ready(function () {
                // Doing this on document ready as well - the above call works as expected when the list control is rendered with the page
                // However, if the control is rendered from a backend call, it appears this initialize() method is getting called before
                // our detail has a height, and thus doesn't initially scroll to the bottom.
                listApi.detail.scrollDetailToBottom();
            });

            // load the corresponding detail when a list item is clicked
            listApi.onItemClick(function (e, context) {

                // Set title
                listApi.detail.updateTitle(context.MessageThreadTitle);

                // load detail
                _loadDetail(context.ContactLogCrmFolderKey);
            });

            // load detail for new message
            $.js(jsSelectors.newThreadButton, { required: false }).on("click", function () {
                listApi.unSelectItems();
                listApi.detail.initializeDetail();
                listApi.detail.updateTitle("New Message Thread");
                _loadDetail(-1);
            });

            // load detail for given crm folder key
            function _loadDetail(contactLogCrmFolderKey) {

                // Load the message thread detail partial view
                $.get(
                    backendUrls.getMessageThreadDetail,
                    {
                        contactLogCrmFolderKey: contactLogCrmFolderKey
                    })
                    .done(function (html) {
                        listApi.detail.loadDetail(html);
                        listApi.detail.scrollDetailToBottom();
                    })
                    .fail(function () {
                        // if the detail retrieve failed, show empty detail
                        listApi.detail.clearDetail();
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);